import { QueryParamsEnum, TripType } from '@honeycomb/data';
import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function hotelContinueToBookRoute({ tripState, summaryRouting, optionalHotelTransfersEnabled, }) {
    var _a, _b, _c, _d, _e;
    const basketHotelItinerary = (_c = (_b = (_a = tripState.basket) === null || _a === void 0 ? void 0 : _a.hotelProducts) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.itinerary;
    let newRoute = summaryRouting ? `/booking/summary/` : `/booking/passengers/`; // Default to bookingRoute
    if (((_d = tripState.searchParameters) === null || _d === void 0 ? void 0 : _d.tripType) === TripType.Holiday) {
        newRoute = '/holidays/flights/options';
    }
    else if (optionalHotelTransfersEnabled || ((_e = basketHotelItinerary === null || basketHotelItinerary === void 0 ? void 0 : basketHotelItinerary.mandatoryExtras) === null || _e === void 0 ? void 0 : _e.length)) {
        newRoute = '/hotels/extras/';
    }
    const paramManager = new QueryParamManager(newRoute, router.currentParams());
    const { tripStateId } = tripState;
    if (tripStateId) {
        paramManager.remove(QueryParamsEnum.TRIP_STATE_ID);
        paramManager.add(QueryParamsEnum.TRIP_STATE_ID, tripStateId);
    }
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function hotelContinueToBookRouting(params, redirect) {
    if (!redirect)
        router.push(params, hotelContinueToBookRoute);
    return hotelContinueToBookRoute(params)[0].toString();
}
